import React from 'react';
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import {
	getLabelColorByStateAndDifficulty,
	getTrackColorByStateAndDifficulty,
	renderLabelHelper
} from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => {
	return renderLabelHelper(coords, color, onLabelClick, '5K', 'Track5KBlue', "10.3242188")
};

const Track5KBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track5KBlue" transform="translate(1464.000000, 392.000000)" className="track">
		<g id="line" strokeLinecap="round"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeWidth={tracksWidth}
		>
			<path
				d="M206,169 L198.091798,167.734436 C193.183687,166.948982 189.841613,162.333435 190.627067,157.425324 C190.967243,155.299651 192.058072,153.366318 193.701663,151.976061 L205.235286,142.220166 C206.500286,141.150146 206.658348,139.257239 205.588328,137.992239 C204.768795,137.02337 203.428305,136.674943 202.240709,137.122108 L153.276984,155.558412 C151.726405,156.142252 149.996116,155.358554 149.412277,153.807974 C149.14354,153.094255 149.15671,152.304979 149.449109,151.600623 L164.018249,116.505224 L164.018249,116.505224"/>
			<line x1="206.535266" y1="169.177883" x2="232.154669" y2="162.945634"/>

			<TrackArrow transform="translate(405.376817, 43.696942) rotate(-64.000000) translate(-405.376817, -43.696942) "
									points="409.376817 51.6969422 401.376817 43.6969422 409.376817 35.6969422"/>
			<path
				d="M387,0.867614989 L387.677042,1.0718274 C403.539718,5.85639685 412.520298,22.5942965 407.735729,38.4569727 C407.346538,39.7472875 406.870841,41.0099095 406.311868,42.2362582 L404.716296,45.7368374 L404.716296,45.7368374"/>
			<line x1="232" y1="163" x2="350" y2="114"/>
			<line x1="350" y1="114" x2="397.8835" y2="55.7559051"/>



			<path
				d="M164.018249,116.505224 C133.511809,134.583604 86.006053,162.735924 24.9931722,198.892682 C3.39379375,210.892337 -5.66461636,237.259726 4,260"/>
		</g>

		{renderLabel("271.595976, 121.000000", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("363.595976, 57.000000", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("83.762970, 135.600578", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("3.762970, 315.600578", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
	</g>
);

Track5KBlue.propTypes = trackPropTypes;

export default Track5KBlue;
